import {Link, Octicon, Box} from '@primer/react'
import {useFragment} from 'react-relay/hooks'

import {getSourceIcon} from '../utils/get-source-icon'
import type {CrossReferencedEvent$key} from './__generated__/CrossReferencedEvent.graphql'
import {issueHovercardPath, issueLinkedPullRequestHovercardPath} from '@github-ui/paths'
import {CrossReferencedEventFragment} from './CrossReferencedEvent'

type CrossReferencedEventInnerProps = {
  queryRef: CrossReferencedEvent$key
}

export function CrossReferencedEventInner({queryRef}: CrossReferencedEventInnerProps): JSX.Element {
  const {source} = useFragment(CrossReferencedEventFragment, queryRef)

  const isIssue = source.__typename === 'Issue'
  const isPullRequest = source.__typename === 'PullRequest'

  if (!isIssue && !isPullRequest) {
    return <></>
  }

  const state = isPullRequest ? source.state : undefined
  const stateReason = isIssue ? source.stateReason : undefined
  const isDraft = isPullRequest ? source.isDraft : undefined
  const isInMergeQueue = isPullRequest ? source.isInMergeQueue : undefined

  const icon = getSourceIcon(source.__typename, state, stateReason, isDraft, isInMergeQueue)

  const dataHovercardUrl =
    source.repository && source.number
      ? isIssue
        ? issueHovercardPath({
            repo: source.repository.name,
            owner: source.repository.owner.login,
            issueNumber: source.number,
          })
        : issueLinkedPullRequestHovercardPath({
            owner: source.repository.owner.login,
            repo: source.repository.name,
            pullRequestNumber: source.number,
          })
      : null

  return (
    <Box>
      <Octicon icon={icon.icon} sx={{ml: 1, mr: 2, color: icon.color}} />
      <Link
        href={source.url}
        target="_blank"
        sx={{color: 'fg.default', mr: 1}}
        data-hovercard-url={dataHovercardUrl}
        muted
      >
        {`${source.title} #${source.number}`}
      </Link>
    </Box>
  )
}

try{ CrossReferencedEventInner.displayName ||= 'CrossReferencedEventInner' } catch {}